import { Camera, CameraPermissionState } from '@capacitor/camera';
import { isPlatform } from '@ionic/vue';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { captureException } from '@sentry/vue';

export const useCameraPermission = defineStore('camera-permission', () => {
  const status = ref<CameraPermissionState>('prompt');
  const isTurnedOn = ref(true);

  const shouldPrompt = computed(() => status.value === 'prompt' || status.value === 'prompt-with-rationale');
  const ready = computed(() => (status.value === 'granted' || status.value === 'limited') && isTurnedOn.value);

  async function onAppResume() {
    if (!isPlatform('hybrid')) {
      status.value = 'granted';
      isTurnedOn.value = true;
      return;
    }
    try {
      console.log('Checking Camera Permissions...');
      const permissions = await Camera.checkPermissions();
      console.log('Checked Camera permissions', permissions.camera);
      isTurnedOn.value = true;
      status.value = permissions.camera;
    } catch (e) {
      console.error('Error checking camera permissions', e);
      isTurnedOn.value = false;
      captureException(e);
    }
  }

  async function prompt() {
    if (!shouldPrompt.value) {
      return;
    }
    try {
      console.log('Requesting camera permissions...');
      const permissions = await Camera.requestPermissions({ permissions: ['camera'] });
      console.log('Requested camera permissions', permissions.camera);
      isTurnedOn.value = true;
      status.value = permissions.camera;
    } catch (e) {
      console.error('Error requesting Camera permissions', e);
      isTurnedOn.value = false;
      captureException(e);
    }
  }

  return {
    ready,
    prompt,
    onAppResume,
  };
});
